export default __webpack_public_path__ + "static/media/k_wdt_c_2.8693caea.mp3";